/** Normalize transport message payloads in place, preserving existing caller semantics. */
export function transformMessageData(messageData: any) {
  // Transform sender object to flat properties
  if (messageData.sender) {
    messageData.sender_id = messageData.sender.id
    messageData.sender_name = messageData.sender.name
    messageData.sender_role = messageData.sender.role
    delete messageData.sender
  }

  // Transform quote_message to quote for frontend compatibility
  if (messageData.quote_message) {
    messageData.quote = {
      id: messageData.quote_message.id,
      change_sequence: messageData.quote_message.change_sequence,
      text: messageData.quote_message.text,
      sender_name: messageData.quote_message.sender?.name || messageData.quote_message.sender_name,
      attachments: messageData.quote_message.attachments
    }
    delete messageData.quote_message
  } else if (messageData.quote_message === null) {
    messageData.quote = undefined
    delete messageData.quote_message
  }

  return messageData
}
